(function (fox, $){
    'use strict';
    fox.registerWidget('PopupWidget', {
        configure: function (options){
            this.registerOptions('', {
                template: '',
                additionalClass: '',
                autoReposition: true,
                repositionTopSpace: 0,
                dialog: {
                    autoOpen: options.autoOpen || false,
                    dialogClass: 'dlg-amc dark-overlay',
                    title: options.title,
                    closeText: '',
                    width: 'auto'
                },
                handleWom: {
                    dOnShow: {
                        event: 'show',
                        widget: '@this',
                        'params.prefix': 'uniqPopEvent',
                        callback: function () {
                            $(fox.dom.selectFirst('.wrapper')).addClass('blured');

                            if (this.getOption('autoReposition') === true) {
                                setTimeout(fox.bind(function (){
                                    this._switchChangeEvents(true);
                                    this.switchPositionPopupClass(true);
                                }, this), 50);
                            }
                        }
                    },
                    dOnHide: {
                        event: 'hide',
                        widget: '@this',
                        'params.prefix': 'uniqPopEvent',
                        callback: function () {
                            $(fox.dom.selectFirst('.wrapper')).removeClass('blured');
                          
                            if (this.getOption('autoReposition') === true) {
                                this._switchChangeEvents(false);
                                this.switchPositionPopupClass(false);
                            }
                        }
                    },
                    centering1: {
                        event: 'addedToDom',
                        widget: '@this ~.Widget',
                        callback: function () {
                            this._center();
                        },
                        'params.prefix': 'centering_popup'
                    },
                    centering2: {
                        event: 'playerRunning',
                        widget: '@this ~.Html5Player',
                        callback: function () {
                            this._center();
                        },
                        'params.prefix': 'centering_popup'
                    }
                }
            });
            
            this.callParent('configure', arguments);
        },

        init: function () {
            this
                .setOption('dialog.dialogClass', this.getOption('dialog.dialogClass') + ' ' + this.getOption('additionalClass'));

            if (this.getOption('autoReposition') === true) {
                var that = this;

                this._callReposition = function(event) {
                    if (that.timerId) {
                        window.clearTimeout(that.timerId);
                        that.timerId = false;
                    }

                    that.timerId = window.setTimeout(function() {
                        that.reposition(event.type);
                    }.bind(that), 300);
                };
            }

            this.callParent('init', arguments);
        },

        embed: function() {
            this.callParent('embed', arguments);

            this.toggleHidden(true);

            if (fox.utils.isTouchDevice()) {
                this.addTouchEvents();
            }
        },

        addTouchEvents: function() {
            this.dialogMethod('widget')
                .find('.ui-dialog-titlebar-close')
                .on('touchend', function(e) {
                    e.preventDefault();
                    this.click();
                });
        },

        setButtonsId: function () {
            if (this.getOption('dialog.buttons')) {
                fox.each(this.getOption('dialog.buttons'), function (val, key) {
                    val.id = val.id ? val.id + '_' + this.getId() : val.text.toLowerCase() + '_' + this.getId();
                }, this);

            } else return;
        },

        dialogDestroy: function () {
            this.dialogMethod('destroy');
           
            return this;
        },

        _switchChangeEvents: function(type) {
            var nameListener = type ? 'addEventListener' : 'removeEventListener';
            var nameEvent = fox.utils.isTouchDevice() ? 'orientationchange' : 'resize';

            window[nameListener](nameEvent, this._callReposition);
        },

        switchPositionPopupClass: function(state) {
            if (state) {
                var isBig = this.popupIsBig();
                fox.dom[isBig ? 'addClass' : 'removeClass']('dlg-pos-abs', this.element);
                this._reposition(isBig);
            } else {
                fox.dom.removeClass('dlg-pos-abs', this.element);
            }
        },

        popupIsBig: function() {
            return (window.innerHeight - 100) < this.element[0].offsetHeight;
        },

        _reposition: function(state) {
            if (!state) {
                this.toggleHidden(true);
                this._center();
                return;
            }

            this.toggleHidden();

            var top = parseInt(this.getOption('repositionTopSpace'));

            this.element[0].style.top = top + 'px';
            window.scrollTo(0, top);
        },

        reposition: function(eventName) {
            if (this.popupIsBig()) {
                this.switchPositionPopupClass(true);
            } else {
                this._center();
            }
        },

        hide: function() {
			this.callParent('hide', arguments);
            this.toggleHidden();
            
			return this;
        },
        
        toggleHidden: function(state) {
            document.querySelector('html').classList[!!state ? 'add' : 'remove']('hidden-scroll');
        }
        
    }, 'Dialog');
})(fox, fox.jQuery);


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/popupWidget/popupWidget.js
// module id = 71
// module chunks = 0